import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuardadoDatosRegistroService {
  private readonly apiUrl = environment.baseURL
  private readonly clientId = '4b9b9ab5b734408d915ec31751bbf114';

  private readonly httpClient: HttpClient = inject(HttpClient);

  postNuevaConsulta(req: any): Observable<any> {
    const params = new HttpParams().set('client-id', this.clientId);
    return this.httpClient.post<any>(this.apiUrl + 'datos-personales/datos-personales-paciente', req, { params });
  }
}

